/**
 * Convert a duration in seconds to a human-readable Mongolian string.
 *
 * Examples:
 *   0      → "—"
 *   NaN    → "—"
 *   45     → "<1мин"
 *   130    → "2мин"
 *   5400   → "1ц 30мин"
 *   172800 → "2 өдөр 0ц"
 */
import { i18n } from "@dehub/theme";

export function formatDuration(seconds: number): string {
  if (!seconds || !Number.isFinite(seconds) || seconds <= 0) return i18n.t("common:duration.none");

  const totalMinutes = Math.floor(seconds / 60);
  if (totalMinutes < 1) return i18n.t("common:duration.lessThanMin");

  const totalHours = Math.floor(seconds / 3600);
  if (totalHours < 1) return i18n.t("common:duration.minutes", { count: totalMinutes });

  const totalDays = Math.floor(seconds / 86400);
  const remainingHours = totalHours % 24;
  const remainingMinutes = totalMinutes % 60;

  if (totalDays >= 1) {
    return i18n.t("common:duration.daysHours", { days: totalDays, hours: remainingHours });
  }

  return remainingMinutes > 0
    ? i18n.t("common:duration.hoursMinutes", { hours: totalHours, minutes: remainingMinutes })
    : i18n.t("common:duration.hours", { count: totalHours });
}
